import React, {useState, Fragment, useRef, useContext, useEffect} from 'react';
import {getCategoriasReunioes, getReunioes} from '../../../../pages/requests';

import {useTranslation} from 'react-i18next';
import {Context} from '../../../../Helpers/Auth';
import MultiSelect from '../../../Selects/MultiSelect';
import MultiSelectColor from '../../../Selects/MultiSelectColor';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function FiltrosTarefas({nomeTarefa, mostraFiltro, representanteFiltro, setRepresentanteFiltro, representantes, setCategoriaFiltro, categoriaFiltro}) {
    const {acessos, utilizador, rep} = useContext(Context);
    const {t} = useTranslation();
    const [activeTab, setActiveTab] = useState(mostraFiltro ? 'filtros' : 'tarefas');
    const [categorias, setCategorias] = useState('');
    const [showFilters, setShowFilters] = useState(false);
    const [reunioesVisita, setReunioesVisita] = useState([]);

    const idiomaAtual = localStorage.getItem('i18nextLng');

    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

    const handleTabClick = tabId => {
        setActiveTab(tabId);
    };

    useEffect(() => {
        getCategoriasReunioes(lang).then(res => {
            setCategorias(res.data.categorias);
        });
    }, []);

    function handleShowFilter() {
        if (showFilters) {
            setShowFilters(false);
        } else {
            setShowFilters(true);
        }
    }
    return (
        <div className="w-full bg-white border border-gray-200 rounded-[8px] shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="sm:hidden">
                <select
                    value={activeTab}
                    onChange={e => handleTabClick(e.target.value)}
                    id="tabs"
                    className="bg-gray-50 border-0 border-b border-gray-200 text-gray-900 text-sm rounded-t-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                    <option>Statistics</option>
                    <option>Services</option>
                </select>
            </div>
            <ul
                className="hidden text-sm font-medium text-center text-gray-500 divide-x divide-gray-200 rounded-[8px] sm:flex dark:divide-gray-600 dark:text-gray-400"
                id="fullWidthTab"
                data-tabs-toggle="#fullWidthTabContent"
                role="tablist">
                {mostraFiltro && (
                    <li className="w-full">
                        <button
                            id="filtros-tab"
                            data-tabs-target="#filtros"
                            type="button"
                            role="tab"
                            aria-controls="filtros"
                            aria-selected={activeTab === 'filtros'}
                            className={`inline-block w-full p-4 rounded-tl-[8px] ${
                                activeTab === 'filtros' ? 'bg-blue-600 text-white dark:text-blue-600' : 'bg-gray-100 hover:bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white'
                            } focus:outline-none  ${activeTab === 'filtros' ? 'dark:text-white' : ''}`}
                            onClick={() => handleTabClick('filtros')}>
                            {t('filtros')}
                        </button>
                    </li>
                )}
                <li className="w-full">
                    <button
                        id="tarefas-tab"
                        data-tabs-target="#tarefas"
                        type="button"
                        role="tab"
                        aria-controls="tarefas"
                        aria-selected={activeTab === 'tarefas'}
                        className={`inline-block w-full p-4 ${mostraFiltro ? 'rounded-tr-[8px]' : 'rounded-tr-[8px] rounded-tl-[8px]'}  ${
                            activeTab === 'tarefas' ? 'bg-blue-600 text-white dark:text-blue-600' : 'bg-gray-100 hover:bg-gray-200 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-white'
                        } focus:outline-none  ${activeTab === 'tarefas' ? 'dark:text-white' : ''}`}
                        onClick={() => handleTabClick('tarefas')}>
                        {nomeTarefa}
                    </button>
                </li>
            </ul>
            <div id="fullWidthTabContent" className="border-t border-gray-200 dark:border-gray-600">
                {mostraFiltro && (
                    <div className={`p-2 bg-white rounded-[8px] md:p-2 dark:bg-gray-800 ${activeTab === 'filtros' ? '' : 'hidden'}`} id="filtros" role="tabpanel" aria-labelledby="filtros-tab">
                        <div>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                    </svg>
                                </div>
                                <input
                                    type="search"
                                    id="default-search"
                                    className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    placeholder={t('filtro')}
                                />
                            </div>
                        </div>
                        <div className="mt-4">
                            <MultiSelect
                                isMulti
                                options={representantes}
                                // value={categoriaFiltro}
                                onChange={e => {
                                    setRepresentanteFiltro(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtrarColaborador')}
                            />
                        </div>
                        <div className="mt-4">
                            <MultiSelectColor
                                isMulti
                                options={categorias}
                                //  value={categoriaFiltro}
                                onChange={e => {
                                    setCategoriaFiltro(e);
                                }}
                                noOptionsMessage={t('semopcoes')}
                                placeholder={t('filtrarCategoria')}
                            />
                        </div>
                    </div>
                )}

                <div className={`p-2 bg-white rounded-[8px] md:p-2 dark:bg-gray-800 ${activeTab === 'tarefas' ? '' : 'hidden'}`} id="tarefas" role="tabpanel" aria-labelledby="tarefas-tab">
                    <div className="mb-4">
                        <div className="relative">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                <svg className="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                                </svg>
                            </div>
                            <input
                                type="search"
                                id="default-search"
                                className="block w-full p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-[8px] bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={t('filtro')}
                            />
                            <button
                                type="submit"
                                onClick={() => {
                                    handleShowFilter();
                                }}
                                className="absolute top-0 right-0 p-1.5 text-sm font-medium h-full text-white bg-blue-700 rounded-r-[8px] border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                {showFilters ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon />}
                                <span className="sr-only">Search</span>
                            </button>
                        </div>
                    </div>
                    {showFilters ? (
                        <>
                            <div className="mt-2">
                                <MultiSelect
                                    options={categorias}
                                    // value={categoriaFiltro}
                                    onChange={e => {
                                        setCategoriaFiltro({
                                            value: e.id,
                                            label: e.descricao,
                                            cor: e.cor,
                                        });
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtrarColaborador')}
                                />
                            </div>
                            <div className="mt-2 mb-2">
                                <MultiSelectColor
                                    options={categorias}
                                    // value={categoriaFiltro}
                                    onChange={e => {
                                        setCategoriaFiltro({
                                            value: e.id,
                                            label: e.descricao,
                                            cor: e.cor,
                                        });
                                    }}
                                    noOptionsMessage={t('semopcoes')}
                                    placeholder={t('filtrarCategoria')}
                                />
                            </div>
                        </>
                    ) : (
                        ''
                    )}
                    <div className="sm:overflow-y-auto max-h-[500px]">
                        <div className="w-full mb-2 bg-white border border-gray-200 rounded-[8px] shadow dark:bg-gray-600 dark:border-gray-700">
                            <div className="flex flex-row w-full mb-2 p-2 bg-gray-200 dark:bg-gray-400 rounded-tr-[8px] rounded-tl-[8px]">
                                <div className="flex flex-col">
                                    <p className="align-center mr-2 text-white dark:text-red-600 text-[1px] bg-red-600 dark:bg-white rounded-full px-1 py-1">
                                        <ReportProblemRoundedIcon />
                                    </p>
                                </div>
                                <div className="flex flex-col ">
                                    <div className="flex flex-row">
                                        <p className="align-center text-white font-bold dark:text-red-600 text-[12px] bg-red-600 dark:bg-white rounded-full px-1 "> 3456789</p>
                                    </div>
                                    <p className="align-center  font-semibold dark:text-gray-700 text-sm  rounded-full  ">Tarefa a ser alocada</p>
                                </div>
                            </div>
                            <div className="p-2">
                                <div>
                                    <p className="align-center mb-2  dark:text-white font-bold text-sm  rounded-full  ">Em curso</p>
                                </div>
                                <div>
                                    <span className="align-center dark:text-white text-gray-700  text-base  rounded-full  ">Tratar avaria setor 4</span>
                                </div>
                                <div className="align-ce">
                                    <AccountCircleIcon />
                                    <span className="ml-2  align-center dark:text-white text-gray-700  text-base  rounded-full  ">Jorge Pereira</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full mb-2 bg-white border border-gray-200 rounded-[8px] shadow dark:bg-gray-600 dark:border-gray-700">
                            <div className="flex flex-row w-full mb-2 p-2 bg-gray-200 dark:bg-gray-400 rounded-tr-[8px] rounded-tl-[8px]">
                                <div className="flex flex-col">
                                    <p className="align-center mr-2 text-white dark:text-red-600 text-[1px] bg-red-600 dark:bg-white rounded-full px-1 py-1">
                                        <ReportProblemRoundedIcon />
                                    </p>
                                </div>
                                <div className="flex flex-col ">
                                    <div className="flex flex-row">
                                        <p className="align-center text-white font-bold dark:text-red-600 text-[12px] bg-red-600 dark:bg-white rounded-full px-1 "> 3456789</p>
                                    </div>
                                    <p className="align-center  font-semibold dark:text-gray-700 text-sm  rounded-full  ">Tarefa a ser alocada</p>
                                </div>
                            </div>
                            <div className="p-2">
                                <div>
                                    <p className="align-center mb-2  dark:text-white font-bold text-sm  rounded-full  ">Em curso</p>
                                </div>
                                <div>
                                    <span className="align-center dark:text-white text-gray-700  text-base  rounded-full  ">Tratar avaria setor 4</span>
                                </div>
                                <div className="align-ce">
                                    <AccountCircleIcon />
                                    <span className="ml-2  align-center dark:text-white text-gray-700  text-base  rounded-full  ">Jorge Pereira</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full mb-2 bg-white border border-gray-200 rounded-[8px] shadow dark:bg-gray-600 dark:border-gray-700">
                            <div className="flex flex-row w-full mb-2 p-2 bg-gray-200 dark:bg-gray-400 rounded-tr-[8px] rounded-tl-[8px]">
                                <div className="flex flex-col">
                                    <p className="align-center mr-2 text-white dark:text-red-600 text-[1px] bg-red-600 dark:bg-white rounded-full px-1 py-1">
                                        <ReportProblemRoundedIcon />
                                    </p>
                                </div>
                                <div className="flex flex-col ">
                                    <div className="flex flex-row">
                                        <p className="align-center text-white font-bold dark:text-red-600 text-[12px] bg-red-600 dark:bg-white rounded-full px-1 "> 3456789</p>
                                    </div>
                                    <p className="align-center  font-semibold dark:text-gray-700 text-sm  rounded-full  ">Tarefa a ser alocada</p>
                                </div>
                            </div>
                            <div className="p-2">
                                <div>
                                    <p className="align-center mb-2  dark:text-white font-bold text-sm  rounded-full  ">Em curso</p>
                                </div>
                                <div>
                                    <span className="align-center dark:text-white text-gray-700  text-base  rounded-full  ">Tratar avaria setor 4</span>
                                </div>
                                <div className="align-ce">
                                    <AccountCircleIcon />
                                    <span className="ml-2  align-center dark:text-white text-gray-700  text-base  rounded-full  ">Jorge Pereira</span>
                                </div>
                            </div>
                        </div>
                        <div className="w-full mb-2 bg-white border border-gray-200 rounded-[8px] shadow dark:bg-gray-600 dark:border-gray-700">
                            <div className="flex flex-row w-full mb-2 p-2 bg-gray-200 dark:bg-gray-400 rounded-tr-[8px] rounded-tl-[8px]">
                                <div className="flex flex-col">
                                    <p className="align-center mr-2 text-white dark:text-red-600 text-[1px] bg-red-600 dark:bg-white rounded-full px-1 py-1">
                                        <ReportProblemRoundedIcon />
                                    </p>
                                </div>
                                <div className="flex flex-col ">
                                    <div className="flex flex-row">
                                        <p className="align-center text-white font-bold dark:text-red-600 text-[12px] bg-red-600 dark:bg-white rounded-full px-1 "> 3456789</p>
                                    </div>
                                    <p className="align-center  font-semibold dark:text-gray-700 text-sm  rounded-full  ">Tarefa a ser alocada</p>
                                </div>
                            </div>
                            <div className="p-2">
                                <div>
                                    <p className="align-center mb-2  dark:text-white font-bold text-sm  rounded-full  ">Em curso</p>
                                </div>
                                <div>
                                    <span className="align-center dark:text-white text-gray-700  text-base  rounded-full  ">Tratar avaria setor 4</span>
                                </div>
                                <div className="align-ce">
                                    <AccountCircleIcon />
                                    <span className="ml-2  align-center dark:text-white text-gray-700  text-base  rounded-full  ">Jorge Pereira</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FiltrosTarefas;
